<div class='t-c m-l-a m-r-a bg-black dker p-b-20'>
    <div class="text-center p-5 flex-fs-c relative">
        <!-- <i *ngIf="!global.isMobile()" class="fa fa-arrows-h youtubeDialogResize m-r-10" [class.fa-arrows-h]="!isMaximized()" [class.fa-long-arrow-right]="isMaximized()" click="toggleYTDialog()"></i> -->
        <div class="modal-title text-ellipsis" id='videoPlayerTitle'><strong>{{data.title}}</strong> | {{data.artist}}</div>
        <div class="dialogClose pointer" (click)="closeDialog()"><img src="../../../assets/images/close.svg"></div>
    </div>
    
    <div class='embedVideo'>
        <div id="YTVideo"></div>
    </div>

    <div class="flex-c-c w-full-xs p-20 bg-black dker" *ngIf="data.footer">
        <a class='comment pointer f20 text-muted pointer' routerLink="{{global.videoDetailPrefix}}/{{data.slug}}" (click)="closeDialog()" title="Comment"></a>
        <div class='clapsContDetail relative m-l-20'>
            <sd-clap [data]="{'for':'video','from':'widget','slug':data.slug,'clapsCount':data.clapsCount,'totalClapsCount':data.totalClapsCount}" title="Clap"></sd-clap>
        </div>
        <a class='shareimg pointer m-l-20 f20 text-muted' (click)="openShareDialog('video',data.slug,data.title,data.artist,data.image)" title="Share"></a>
    </div>
</div>
